import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const createBooking = (data) =>
  axios.post(`${API}/bookings`, data).then((r) => r.data);

export const createContact = (data) =>
  axios.post(`${API}/contact`, data).then((r) => r.data);

export const createReview = (data) =>
  axios.post(`${API}/reviews`, data).then((r) => r.data);

export const getReviews = () =>
  axios.get(`${API}/reviews`).then((r) => r.data);

export const createOrder = (data) =>
  axios.post(`${API}/payments/create-order`, data).then((r) => r.data);

export const verifyPayment = (data) =>
  axios.post(`${API}/payments/verify`, data).then((r) => r.data);
